import { ReceiptText, Zap } from "lucide-react";

import type { CaptainBillingHistorySource } from "./types";

export const CAPTAIN_BALANCE_CHANGED = "captain-billing:balance-changed";

export const CaptainTokensIcon = Zap;

export const CaptainBillingIcon = ReceiptText;

export const BALANCE_FILL: Record<CaptainBillingHistorySource, string> = {
  cap: "bg-primary",
  topUp: "bg-chart-1",
};

export const CAPTAIN_USAGE_MONTHS = 12;

export const HISTORY_SOURCES: CaptainBillingHistorySource[] = ["cap", "topUp"];

export const BALANCE_CHART_COLOR: Record<CaptainBillingHistorySource, string> = {
  cap: "var(--primary)",
  topUp: "var(--chart-1)",
};
